import { getGlobalSlardarInitStatus } from "./global-slardar-on-init";
function createMockSlardar() {
  const actions = [];
  const mockSlardar = function(...args) {
    if (mockSlardar.mock) {
      actions.push(args);
    } else {
      Object.setPrototypeOf(mockSlardar, mockSlardar.slardar);
      mockSlardar.slardar(...args);
    }
  };
  mockSlardar.flush = function(slardarInstance) {
    actions.forEach((args) => {
      slardarInstance.apply(slardarInstance, args);
    });
    mockSlardar.mock = false;
    mockSlardar.slardar = slardarInstance;
  };
  mockSlardar.mock = true;
  return mockSlardar;
}
export {
  createMockSlardar,
  getGlobalSlardarInitStatus
};

//# sourceMappingURL=mock-global-slardar.js.map